import {
  createCategoryApi,
  deleteCategoryApi,
  getCategoriesApi,
  getSingleCategoryByIdApi,
  updateCategoryApi,
} from "api/categories";
import {
  takeEvery,
  fork,
  put,
  all,
  call,
  takeLatest,
} from "redux-saga/effects";
import {
  createCategoryFailure,
  createCategorySuccess,
  deleteCategoryFailure,
  deleteCategorySuccess,
  getCategoriesFailure,
  getCategoriesSuccess,
  getSingleCategoryFailure,
  getSingleCategorySuccess,
  updateCategoryFailure,
  updateCategorySuccess,
} from "./actions";
import {
  CREATE_CATEGORY,
  DELETE_CATEGORY,
  GET_CATEGORIES,
  GET_SINGLE_CATEGORY,
  UPDATE_CATEGORY,
} from "./actionTypes";

function* getCategoriesSaga({ payload }) {
  try {
    const { data } = yield call(getCategoriesApi, payload);
    yield put(getCategoriesSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getCategoriesFailure(error));
  }
}

// ===================================================
// ===================================================

function* getSingleCategorySaga({ payload }) {
  try {
    const { data } = yield call(getSingleCategoryByIdApi, payload);
    yield put(getSingleCategorySuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getSingleCategoryFailure(error));
  }
}

// ===================================================
// ===================================================

function* createCategorySaga({ payload }) {
  try {
    const { data, success } = yield call(createCategoryApi, payload);
    yield put(createCategorySuccess(data));
    if (success) {
      yield payload?.toast?.success("تم إنشاء التصنيف بنجاح");
      yield payload?.navigate("/categories");
    }
  } catch (error) {
    console.log(error);
    yield put(createCategoryFailure(error));
  }
}

// ===================================================
// ===================================================

function* updateCategorySaga({ payload }) {
  try {
    const { data, success } = yield call(updateCategoryApi, payload);
    yield put(updateCategorySuccess(data));
    if (success) {
      yield payload?.toast?.success("تم تحديث التصنيف بنجاح");
      yield payload?.navigate("/categories");
    }
  } catch (error) {
    console.log(error);
    yield put(updateCategoryFailure(error));
  }
}

// ===================================================
// ===================================================

function* deleteCategorySaga({ payload }) {
  try {
    yield call(deleteCategoryApi, payload);
    yield put(deleteCategorySuccess(payload));
  } catch (error) {
    console.log(error);
    yield put(deleteCategoryFailure(error));
  }
}

// ===================================================
// ===================================================

export function* watchGetCategories() {
  yield takeEvery(GET_CATEGORIES, getCategoriesSaga);
}

export function* watchGetSingleCategory() {
  yield takeLatest(GET_SINGLE_CATEGORY, getSingleCategorySaga);
}

export function* watchCreateCategory() {
  yield takeLatest(CREATE_CATEGORY, createCategorySaga);
}

export function* watchUpdateCategory() {
  yield takeLatest(UPDATE_CATEGORY, updateCategorySaga);
}
export function* watchDeleteCategory() {
  yield takeLatest(DELETE_CATEGORY, deleteCategorySaga);
}

// ===================================================
// ===================================================

function* categoriesSaga() {
  yield all([fork(watchGetCategories)]);
  yield all([fork(watchGetSingleCategory)]);
  yield all([fork(watchDeleteCategory)]);
  yield all([fork(watchUpdateCategory)]);
  yield all([fork(watchCreateCategory)]);
}

export default categoriesSaga;
